import { useDispatch, useSelector } from 'react-redux';
import Button from '../extras/Button';
import Input from '../extras/Input';
import { useEffect, useState } from 'react';
import { closeDialog } from '../../redux/slice/dialogueSlice';
import {
  addWithDraw,
  getWithDraw,
  updateWithDraw,
} from '../../redux/slice/withDrawSlice';
import { toast } from 'react-toastify';
import { permissionError } from '../../util/Alert';
import { Box, Modal } from '@mui/material';
import { IconPlus } from '@tabler/icons-react';

const WithDrawDialogue = ({ page, rowsPerPage }) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const hasPermission = useSelector((state) => state.auth.admin.flag);
  const [mongoId, setMongoId] = useState('');
  const [name, setName] = useState();
  const [addDetail, setAddDetail] = useState([]);
  const [image, setImage] = useState([]);
  const [imagePath, setImagePath] = useState('');

  const [detail, setDetail] = useState('');

  const [error, setError] = useState({
    name: '',
    imagePath: '',
    addDetail: [],
  });

  useEffect(() => {
    setMongoId(dialogueData?._id);
    setName(dialogueData?.name);
    setImagePath(dialogueData?.image);
    setImage(dialogueData?.image);
    setAddDetail(dialogueData?.details);
  }, [dialogueData]);
  const dispatch = useDispatch();

  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
    setError((prevErrors) => ({
      ...prevErrors,
      image: '',
    }));
  };
  const addCountryList = (e) => {
    e.preventDefault();
    setAddDetail((old) => {
      if (!Array.isArray(old)) {
        old = [];
      }
      return [...old, detail];
    });
    setDetail('');
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      addCountryList(event);
    }
  };

  const onRemove = (id) => {
    setAddDetail((old) => {
      if (!Array.isArray(old)) {
        old = [];
      }
      return old.filter((array, index) => {
        return index !== id;
      });
    });
  };

  const validate = () => {
    let errors = {};
    let isValid = true;

    if (!name) {
      errors.name = 'Name is required!';
      isValid = false;
    }
    if (!image || image?.length === 0) {
      errors.image = 'Image is required!';
      isValid = false;
    }
    if (!addDetail || addDetail.length === 0) {
      errors.detail = 'Details are required!';
      isValid = false;
    }

    setError(errors); // Set errors after validation
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!hasPermission) return permissionError();
    if (validate()) {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('image', image);
      formData.append('details', addDetail);
      if (mongoId) {
        const payload = {
          formData,
          id: mongoId,
        };
        dispatch(updateWithDraw(payload)).then((res) => {
          if (res?.payload?.status) {
            toast.success(res?.payload?.message);
            const payload = {
              start: page,
              limit: rowsPerPage,
            };
            dispatch(getWithDraw(payload));
            dispatch(closeDialog());
          } else {
            toast.error(res?.payload?.message);
          }
        });
      } else {
        dispatch(addWithDraw(formData)).then((res) => {
          if (res?.payload?.status) {
            toast.success(res?.payload?.message);
            const payload = {
              start: page,
              limit: rowsPerPage,
            };
            dispatch(getWithDraw(payload));
            dispatch(closeDialog());
          } else {
            toast.error(res?.payload?.message);
          }
        });
      }
    }
  };
  return (
    <>
      <Modal
        open={true}
        onClose={closeDialog}
      >

        <Box className="model-style">
          <div className="model-header">
            <p className="m-0">Withdraw</p>
          </div>

          <div className="model-body">


            <div className="row align-items-start formBody">
              <div className="inputData text">
                <label htmlFor="name" className=" order-1">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={name}
                  placeholder="Enter name"
                  onChange={(e) => {
                    setName(e.target.value);
                    setError({ ...error, name: '' });
                  }}
                />
                {error?.name && (
                  <div
                    className="error-message"
                    style={{ color: 'red', fontSize: '12px' }}
                  >
                    {' '}
                    {error.name}
                  </div>
                )}
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center">
                  <div className="inputData text flex-row justify-content-start text-start w-100">
                    <label htmlFor="detail" className=" order-1">
                      Details
                    </label>
                    <div className='d-flex gap-2 '>
                      <input
                        type="text"
                        className="form-control"
                        name="detail"
                        value={detail}
                        placeholder="Enter detail"
                        onChange={(e) => {
                          setDetail(e.target.value);
                          setError({ ...error, detail: '' });
                        }}
                      />
                      <div className='action-button'>
                        <button className='btn btn-sm bg-secondary border-0' onClick={addCountryList} disabled={detail === ''}>
                          <IconPlus className='text-light' />
                        </button>
                      </div>
                    </div>
                    {error?.detail && (
                      <div
                        className="error-message"
                        style={{ color: 'red', fontSize: '12px' }}
                      >
                        {' '}
                        {error.detail}
                      </div>
                    )}
                  </div>
                  {/* {detail !== '' && (
                    <div
                      className="px-3 text-white d-flex align-items-center justify-content-center ms-3 w-25 "
                      style={{
                        borderRadius: '5px',
                        cursor: 'pointer',
                        backgroundColor: '#1C2B20',
                        padding: '6px 0px',
                        marginTop: '30px',
                      }}
                      onClick={addCountryList}
                    >
                      <span>ADD</span>
                    </div>
                  )} */}
                </div>
              </div>
            </div>

            {addDetail?.length && <div className="d-flex gap-1">
              {addDetail?.map((item, id) => {
                return (
                  <>
                    <div
                      className=""
                      style={{
                        backgroundColor: ' #1C2B20',
                        padding: '5px',
                        color: ' #fff',
                        borderRadius: '5px',
                      }}
                    >
                      {item}
                      <i
                        className="fa-solid fa-circle-xmark ms-2 my-2"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          onRemove(id);
                        }}
                      ></i>
                    </div>
                  </>
                )
              })}
            </div>}
            <div className="inputData file  flex-row justify-content-start text-start">
              <label htmlFor="image" className=" order-1">
                Image
              </label>
              <input
                type="file"
                className="form-control"
                id="image"
                onChange={(e) => handleImage(e)}
                accept="image/*"
              />
              {error?.image && (
                <div
                  className="error-message"
                  style={{ color: 'red', fontSize: '12px' }}
                >
                  {' '}
                  {error.image}
                </div>
              )}
              {imagePath && (
                <div className="image-start">
                  <img
                    src={imagePath}
                    alt="ServiceImage"
                    draggable="false"
                    className={`${(!imagePath || imagePath == '') && 'd-none'
                      }`}
                    width={'100px'}
                    height={'100px'}
                    // data-image={name}
                    data-class={`showImage`}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="model-footer">

            <div className="m-3 d-flex justify-content-end gap-2">
              <Button
                className={`close-model-btn`}
                text={`Cancel`}
                type={`button`}
                onClick={() => dispatch(closeDialog())}
              />
              <Button
                type={`submit`}
                text={`Submit`}
                onClick={(e) => handleSubmit(e)}
              />
            </div>

          </div>


        </Box>
      </Modal>


    </>
  );
};
export default WithDrawDialogue;
